import { apiClient } from "./client";

// Сонячні електростанції (FR-SOLAR). Окремий контур від КГУ: у СЕС немає
// плану, балансу, небалансу та оптимізатора.

export type PlantKind = "rooftop" | "ground";

export interface SolarPlant {
  id: string;
  tenant_id: string;
  code: string;
  name: string;
  kind: PlantKind;
  capacity_kwp: number | string | null;
  commissioned_at: string | null;
  is_active: boolean;
  created_at: string;
  current_price_uah_per_kwh: number | string | null;
  current_buy_price_uah_per_kwh: number | string | null;
  source_count: number;
}

export interface SolarPlantWrite {
  code: string;
  name: string;
  kind: PlantKind;
  capacity_kwp?: number | null;
  commissioned_at?: string | null;
  is_active?: boolean;
}

export interface SolarTariff {
  id: string;
  plant_id: string;
  effective_from: string;
  price_uah_per_kwh: number | string;
  buy_price_uah_per_kwh: number | string | null;
  notes: string | null;
  created_at: string;
}

export interface SolarTariffWrite {
  effective_from: string;
  price_uah_per_kwh: number;
  buy_price_uah_per_kwh?: number | null;
  notes?: string | null;
}

export interface SolarHour {
  ts: string;
  plant_id: string;
  export_kwh: number | string | null;
  import_kwh: number | string | null;
  revenue_uah: number | string | null;
  import_cost_uah: number | string | null;
  profit_uah: number | string | null;
  quality: string | null;
}

export interface SolarDay {
  day: string;
  plant_id: string | null;
  export_kwh: number | string | null;
  import_kwh: number | string | null;
  revenue_uah: number | string | null;
  import_cost_uah: number | string | null;
  profit_uah: number | string | null;
  /** Скільки годин доби реально є у вітрині. 0 = даних немає (не «нуль»). */
  hours: number;
  /** Скільки годин мало б бути (23/24/25 або менше для поточної доби). */
  hours_expected: number;
}

export const solarApi = {
  listPlants: (includeInactive = false) =>
    apiClient
      .get<SolarPlant[]>("/solar/plants", {
        params: { include_inactive: includeInactive },
      })
      .then((r) => r.data),
  createPlant: (body: SolarPlantWrite) =>
    apiClient.post<SolarPlant>("/solar/plants", body).then((r) => r.data),
  updatePlant: (id: string, body: SolarPlantWrite) =>
    apiClient.patch<SolarPlant>(`/solar/plants/${id}`, body).then((r) => r.data),

  listTariffs: (plantId: string) =>
    apiClient
      .get<SolarTariff[]>(`/solar/plants/${plantId}/tariffs`)
      .then((r) => r.data),
  putTariffs: (plantId: string, items: SolarTariffWrite[]) =>
    apiClient
      .put<SolarTariff[]>(`/solar/plants/${plantId}/tariffs`, { items })
      .then((r) => r.data),

  hourly: (date: string, plantId?: string) =>
    apiClient
      .get<SolarHour[]>("/solar/metrics/hourly", {
        params: { date, ...(plantId ? { plant_id: plantId } : {}) },
      })
      .then((r) => r.data),
  daily: (from: string, to: string, opts?: { plantId?: string; groupByPlant?: boolean }) =>
    apiClient
      .get<SolarDay[]>("/solar/metrics/daily", {
        params: {
          from,
          to,
          ...(opts?.plantId ? { plant_id: opts.plantId } : {}),
          ...(opts?.groupByPlant === false ? { group_by_plant: false } : {}),
        },
      })
      .then((r) => r.data),
};
